import {isEmpty} from "lodash";
import store from "src/store";
import {LoginComplete} from "src/user/UserActions";
class UserService {
    private static instance: UserService;

    public static getInstance(): UserService {
        if (!UserService.instance) {
            UserService.instance = new UserService();
        }
        return UserService.instance;
    }
    get email() {
        return localStorage.getItem("email");
    }
    set email(email: string) {
        isEmpty(email) ? localStorage.removeItem("email") : localStorage.setItem("email",email);
    }
    clear() {
        this.email = undefined;
        store.dispatch(LoginComplete(undefined));
    }
}
const userService = UserService.getInstance();
export default userService;
